export default {
    AvailableStartTime: 'شروع اعتبار',
    AvailableStartTimeMin: 'شروع اعتبار از',
    AvailableStartTimeMax: 'شروع اعتبار تا',
    AvailableExpireTime: 'پایان اعتبار',
    AvailableExpireTimeMin: 'پایان اعتبار از',
    AvailableExpireTimeMax: 'پایان اعتبار تا',
    CompanyDiscountAmountMin: 'تخفیف باربری از',
    CompanyDiscountAmountMax: 'تخفیف باربری تا',
    CompanyDiscountTypeId: 'نوع تخفیف باربری',
    DeadlineTime: 'مهلت درج',
    DeadlineTimeMin: 'مهلت درج از',
    DeadlineTimeMax: 'مهلت درج تا',
    MarketplaceDiscountType: 'نوع تخفیف باربانت',
    MaximumCompanyDiscountAmount: 'حداکثر مقدار تخفیف باربری',
    MaximumCompanyDiscountAmountMin: 'حداکثر مقدار تخفیف باربری از',
    MaximumCompanyDiscountAmountMax: 'حداکثر مقدار تخفیف باربری تا',
    MarketplaceDiscount: 'تخفیف باربانت',
    MarketplaceDiscountAmountMin: 'تخفیف باربانت از',
    MarketplaceDiscountAmountMax: 'تخفیف باربانت تا',
    MinimumMarketplaceDiscount: 'حداقل مقدار تخفیف باربانت',
    MinimumMarketplaceDiscountAmountMin: 'حداقل مقدار تخفیف باربانت از',
    MinimumMarketplaceDiscountAmountMax: 'حداقل مقدار تخفیف باربانت تا',
    MaximumMarketplaceDiscount: 'حداکثر مقدار تخفیف باربانت',
    MaximumMarketplaceDiscountAmountMin: 'حداکثر مقدار تخفیف باربانت از',
    MaximumMarketplaceDiscountAmountMax: 'حداکثر مقدار تخفیف باربانت تا',
    MinimumCompanyDiscount: 'حداقل مقدار تخفیف باربری',
    MinimumCompanyDiscountAmountMin: 'حداقل مقدار تخفیف باربری از',
    MinimumCompanyDiscountAmountMax: 'حداقل مقدار تخفیف باربری تا',
    MaximumCompanyDiscount: 'حداکثر مقدار تخفیف باربری',
    MaximumCompanyDiscountMin: 'حداکثر مقدار تخفیف باربری از',
    MaximumCompanyDiscountMax: 'حداکثر مقدار تخفیف باربری تا',
    Title: 'عنوان',
    StateId: 'وضعیت',
    Scope: 'حوزه مشارکت',
    Percent: 'درصد',
}